import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Banner } from '../models/banner.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private collectionName = 'banners';

  constructor(private firestore: AngularFirestore, private storage: AngularFireStorage) {}

  // 🔹 Obtener lista de banners
  getBanners(): Observable<Banner[]> {
    return this.firestore
      .collection<Banner>(this.collectionName, (ref) => ref.orderBy('createdAt', 'desc'))
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => {
            const data = a.payload.doc.data() as Banner;
            const id = a.payload.doc.id;
            return { id, ...data };
          })
        )
      );
  }

  // 🔹 Subir imagen a Storage y devolver URL
  async uploadImage(file: File, id: string): Promise<string> {
    const filePath = `${this.collectionName}/${id}_${file.name}`;
    const fileRef = this.storage.ref(filePath);

    await this.storage.upload(filePath, file);
    return fileRef.getDownloadURL().toPromise();
  }

  // 🔹 Crear banner
  async addBanner(banner: Banner, file?: File) {
    const docRef = await this.firestore.collection(this.collectionName).add({
      title: banner.title,
      url: banner.url || '',
      imageUrl: '',
      createdAt: new Date(),
    });

    if (file) {
      const imageUrl = await this.uploadImage(file, docRef.id);
      await docRef.update({ imageUrl });
    }
  }

  // 🔹 Actualizar banner
  async updateBanner(id: string, data: Partial<Banner>, file?: File) {
    if (file) {
      const imageUrl = await this.uploadImage(file, id);
      data.imageUrl = imageUrl;
    }
    return this.firestore.collection(this.collectionName).doc(id).update(data);
  }

  // 🔹 Eliminar banner + imagen de storage
  async deleteBanner(id: string, imageUrl?: string) {
    await this.firestore.collection(this.collectionName).doc(id).delete();

    if (imageUrl) {
      try {
        await this.storage.refFromURL(imageUrl).delete().toPromise();
      } catch (e) {
        console.warn('⚠️ No se pudo eliminar la imagen del storage:', e);
      }
    }
  }
}
